<template>
    <section class="mentor-dashboard" v-if="notes && projects && assets && members && categories">
        <timeline></timeline>
        <div class="row text-right">
            <i class="fa fa-expand" @click="toggleExpand()"></i>
        </div>
        <div class="row">
          
            <mentor-calendar :members="members" :projects="projects" :feed="feed"></mentor-calendar>
        </div>
        <div class="row">
            <div class="col-xs-9 panel main-panel">
                <div class="panel-heading">
                    <h2>Mentorship Notes</h2>
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-7">
                            <ul class="filters">
                                <li>
                                    <select v-model="query.project" @change="getNotes($event, 'project')" class="proj form-control">
                                        <option value="">Project</option>
                                        <option v-for="project in projects" :value="project.id" :style="{backgroundColor: project.color}">
                                            {{project.name}}
                                        </option>
                                    </select>
                                </li>
                                <li>
                                    <select v-model="query.asset" @change="getNotes($event, 'asset')" class="form-control">
                                        <option value="">Asset</option>
                                        <option v-for="asset in assets" :style="{backgroundColor: getProjectColor(asset.projectId)}" :value="asset.id">
                                            {{asset.name}}
                                        </option>
                                    </select>
                                </li>
                                <li>
                                    <select v-model="query.category" @change="getNotes($event, 'category')" class="form-control">
                                        <option value="">Task</option>
                                        <option v-for="category in categories" :value="category.id">
                                            {{category.name}}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xs-2">
                            <input @input="search" v-model="searchTerm" class="form-control" placeholder="Search">
                        </div>
                        <div class="col-xs-3 completed-filter">
                            <a @click.prevent="query.completed = !query.completed;getNotes($event, 'completed')"><span v-if="query.completed">Hide</span><span v-else>Show</span> Completed</a>
                        </div>
                    </div>
                    <div class="timeline-wrapper">
                        <ul class="timeline" v-if="timelineNotes">
                            <li v-for="(value, key) in timelineNotes" @click="goToDate(key)">
                                <div class="day">{{key | timelineDate}}</div>
                                <div class="bubbles">
                                    <span v-for="project in value" class="bubble" :style="{backgroundColor: getProjectColor(project)}">
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <ul class="notes" id="notes" ref="notes" @scroll="handleScroll($event)">
                        <li v-for="(note, $index) in notes" 
                            v-show="query.completed === true || (query.completed === false && note.completed !== true)" 
                            :id="'note'+note.id" 
                            v-bind:key="note.id"
                            @dragover="dragover" 
                            @drop="attachStructure($event, note, $index)">

                            <!-- This is a Meeting note -->
                            <div v-if="note.location && showMeetingNote(note)" class="row">
                                
                                <div class="col-xs-3 col-md-3 col-lg-2 text-center campus-meeting-avatars">
                                    <img v-for="participant in note.participants" class="avatar" :src="getAvatar(participant)">
                                </div>
                                <div class="date">{{note.createdAt | longDate}} <i v-if="note.author == localStorage.user_id" class="fa fa-remove delete-note" @click="deleteNote(note.id, $index)"></i></div>
                                <div class="col-xs-9 col-md-9 col-lg-10 clearfix campus-meeting">
                                    Mentor Meeting, {{getLocationName(note.location)}}
                                    <div v-if="note.meetingNote[0]" class="meeting-notes">
                                        {{note.meetingNote[0].text}}
                                    </div>
                                    <div class="confirm-attendance" v-if="!note.meetingNote[0]">
                                        <label>Did you attend this meeting? 
                                            <input type="checkbox" v-model="note.attended">
                                            <i class="fa fa-check-square-o"></i><i class="fa fa-square-o"></i>
                                        </label>
                                        <div>
                                            <button class="btn btn-xs" @click.prevent="createMeetingNote(note)">Submit</button>
                                        </div>
                                    </div>  
                                        <div class="attendance-confirmed text-right" v-if="note.meetingNote[0] && !note.meetingNote[0].text">
                                            Attended
                                        </div>              

                                </div>
                            </div>

                            <div class="row" v-if="!note.location">
                                <div class="col-xs-3 col-md-3 col-lg-2 text-center">
                                    <img @click="feed=note.author" class="avatar" :src="getAvatar(note.author)">
                                </div>
                                <div class="date">{{note.createdAt | longDate}} <i v-if="note.author == localStorage.user_id" class="fa fa-remove delete-note" @click="deleteNote(note.id, $index)"></i></div>
                                <div :data-id="note.id" :data-created="note.createdAt" :class="{'dark': note.projectIds.length > 0 && note.projectIds[0] !== 'none', 'completed': note.completed}" :style="{backgroundImage: noteColor(note.projectIds)}" class="col-xs-9 col-md-9 col-lg-10 clearfix note-text">
                                    <i class="fa fa-arrows drag-note" :data-id="note.id" :data-created="note.createdAt" v-fcevent></i>
                                    <div class="edit" v-if="note.author == localStorage.user_id || localStorage.roles.includes('Mentor')">
                                        <i v-if="noteToEdit.noteId===note.id" @click="updateNote(note)" class="save-edited-note fa fa-save"></i>
                                        <i v-else class="edit-note fa fa-pencil" @click="noteToEdit.noteId=note.id"></i>
                                    </div>
                                    <div v-if="(!note.categoryIds || note.categoryIds.length === 0)">

                                        <editable class="text" @click.stop v-focus.lazy="noteToEdit.noteId===note.id" :content="note.text" v-if="note.author == localStorage.user_id" @update="noteToEdit.text = $event"></editable>
                                        <div v-if="note.author != localStorage.user_id" class="text uneditable">{{note.text}}</div>
                                    </div>
                                    <div class="tasks" v-if="note.completed !== null">
                                        <div class="task-editor">
                                            <ul class="tasks">
                                                <li v-for="(task, $taskIndex) in note.tasks">
                                                    <div class="task-wrapper">
                                                        <label>
                                                            <i class="fa" @click="task.completed = !task.completed; updateTask({type:'change'}, task, $index, $taskIndex)" :class="{
                                                                'fa-check-square': task.completed === true,
                                                                'fa-square': task.completed === false
                                                            }"></i>
                                                        </label>
                                                        <input v-if="!localStorage.roles.includes('Admin') && selectedTask==='n'+note.id+'_t'+task.id && note.author == localStorage.user_id" @keyup="updateTask($event, task, $index, $taskIndex, note.tasks.length)" :ref="'n'+note.id+'_t'+task.id" class="task-name" type="text" placeholder="Add Task" v-model="task.name">
                                                        <div v-else class="task" @click="selectedTask='n'+note.id+'_t'+task.id" v-html="task.name"></div>
                                                    </div>
                                                    <ul :class="{'dark': note.projectIds.length > 0 && note.projectIds[0] !== 'none'}" v-if="task.children" class="task-children">
                                                        <li v-for="(child, $taskChildIndex) in task.children">
                                                            <label>
                                                                <i class="fa" @click="child.completed = !child.completed; updateTask({type:'change'}, task)" :class="{
                                                                    'fa-check-square': child.completed === true,
                                                                    'fa-square': child.completed === false
                                                                }"></i>
                                                            </label>
                                                            {{'n'+note.id+'_t'+task.id}}
                                                            <input @keyup="updateTask($event, child, $index, $taskIndex, note.tasks.length)" type="text" class="task-name" v-model="child.name">
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <ul class="attachments clearfix" v-if="note.attachments && note.attachments.length > 0">
                                        <li @click="openLightbox(note.attachments, $attachmentIndex)" v-if="isVideo(attachment) || isImage(attachment)" v-for="(attachment, $attachmentIndex) in note.attachments">
                                            <video v-if="isVideo(attachment)">
                                                <source :src="attachment">
                                            </video>
                                            <img v-if="isImage(attachment)" :src="getThumbnail(attachment)">
                                            <div class="hover">
                                                <img v-if="isVideo(attachment)" src="static/static/img/play.png">
                                                <img v-if="isImage(attachment)" src="static/static/img/magnify.png">
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="files" v-if="note.attachments && note.attachments.length > 0">
                                        <li v-for="attachment in note.attachments" v-if="!isVideo(attachment) && !isImage(attachment)">
                                            <a :href="attachment" target="_blank">{{attachment.split('/').pop()}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row nopad" v-if="!note.location && !note.week">
                                <div class="col-xs-10 col-xs-push-2 nopad note-footer">
                                    <span v-for="(project, $projectIndex) in note.projectIds" v-if="project !== 'none'">
                                        <i v-if="noteToEdit.noteId === note.id" @click="removeStructure($index, 'projectIds', project)" class="fa fa-remove"></i>
                                        {{projectName(project)}}<span v-if="$projectIndex < note.projectIds.length - 1">,</span>
                                    </span>
                                    <span v-if="note.projectIds.length > 0 && note.projectIds[0] !== 'none' && (note.assetIds.length > 0 || note.categoryIds.length > 0)">
                                        &gt;</span>
                                    <span v-for="(asset,$assetIndex) in note.assetIds">
                                        <i v-if="noteToEdit.noteId === note.id" @click="removeStructure($index, 'assetIds', asset)" class="fa fa-remove"></i>
                                        {{assetName(asset)}}<span v-if="$assetIndex < note.assetIds.length -1">,</span></span>
                                    <span v-if="note.assetIds.length > 0 && note.categoryIds.length > 0">&gt;</span>
                                    <span v-for="(category,$categoryIndex) in note.categoryIds">
                                        <i v-if="noteToEdit.noteId === note.id" @click="removeStructure($index, 'categoryIds', asset)" class="fa fa-remove"></i>
                                        {{categoryName(category)}}<span v-if="$categoryIndex < note.categoryIds.length -1">,</span></span>
                                </div>
                            </div>
                            <div class="date row nopad text-right">
                                <span v-if="note.dueDate">Due: {{note.dueDate | localLongDate}}</span>
                                <span v-if="note.dueDate && new Date(note.dueDate) > new Date()">(<countdown :date="localTime(note.dueDate)" :fast="true"></countdown>)</span>
                            </div>
                            <div class="row" v-if="note.children && note.children.length > 0">
                                <ul class="children">
                                    <li v-for="(child, $childIndex) in note.children">
                                        <div class="row">
                                            <div class="date"><i v-if="child.author == localStorage.user_id" class="fa fa-remove delete-note" @click="deleteNote(child.id, $index, $childIndex)"></i></div>
                                            <div class="col-xs-3 col-md-2 nopad text-center">
                                                <img class="avatar" @click="feed=child.author" :src="getAvatar(child.author)">
                                            </div>
                                            <div class="col-xs-9 col-md-10 note-text">
                                                <div class="edit" v-if="child.author == localStorage.user_id">
                                                    <i v-if="noteToEdit.noteId===child.id" @click="updateNote(child)" class="save-edited-note fa fa-save"></i>
                                                    <i v-else class="edit-note fa fa-pencil" @click="noteToEdit.noteId=child.id"></i>
                                                </div>
                                                <editable class="text" @click.stop v-if="child.author == localStorage.user_id" v-focus.lazy="noteToEdit.noteId===child.id" :content="child.text" @update="noteToEdit.text = $event"></editable>
                                                <div v-else class="text">{{child.text}}</div>
                                                <ul class="attachments" v-if="child.attachments && child.attachments.length > 0">
                                                    <li @click="openLightbox(child.attachments, $attachmentIndex)" v-for="(attachment, $attachmentIndex) in child.attachments" v-if="isVideo(attachment) || isImage(attachment)">
                                                        <video v-if="isVideo(attachment)">
                                                            <source :src="attachment">
                                                        </video>
                                                        <img v-if="isImage(attachment)" :src="getThumbnail(attachment)">
                                                        <div class="hover">
                                                            <img v-if="isVideo(attachment)" src="static/static/img/play.png">
                                                            <img v-if="isImage(attachment)" src="static/static/img/magnify.png">
                                                        </div>
                                                    </li>
                                                </ul>
                                                <ul class="files" v-if="child.attachments && child.attachments.length > 0">
                                                    <li v-for="attachment in child.attachments" v-if="!isVideo(attachment) && !isImage(attachment)">
                                                        <a :href="attachment" target="_blank">{{attachment.split('/').pop()}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="row nopad">
                                <div class="nopad col-xs-9 col-xs-push-3 note-taker" v-if="replyTo===$index">
                                    <div class="form-group note-taker-wrapper reply-note">
                                        <textarea @keyup.ctrl.enter="sendReply(note)" v-model.trim="replyNote.text" class="form-control reply" placeholder="Write reply here"></textarea>
                                        <label class="attach" :for="'replyAttachments' + note.id"><img src="./../assets/img/paperclip.png"></label>
                                        <input type="file" @change="addAttachments($event, 'reply')" :id="'replyAttachments' + note.id" multiple>
                                        <button :class="{'disabled': uploading===true}" class="send" @click.prevent="sendReply(note)"><img src="./../assets/img/airplane.png"></button>
                                        <ul class="attachments" v-if="replyNote.attachments && replyNote.attachments.length >0">
                                            <li v-for="attachment in replyNote.attachments" v-if="isVideo(attachment) || isImage(attachment)">
                                                <video v-if="isVideo(attachment)">
                                                    <source :src="attachment">
                                                </video>
                                                <img v-if="isImage(attachment)" :src="getThumbnail(attachment)">
                                            </li>
                                        </ul>
                                        <ul class="files" v-if="replyNote.attachments && replyNote.attachments.length >0">
                                            <li v-for="attachment in replyNote.attachments" v-if="!isVideo(attachment) && !isImage(attachment)">
                                                <a :href="attachment" target="_blank">{{attachment.split('/').pop()}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <span class="reply" @click.prevent="replyTo=null">Cancel</span>
                                </div>
                                <span v-else>
                                    <span v-if="!note.location" class="reply" @click.prevent="replyTo=$index">Reply</span>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="note-taker row nopad">
                    <div class="col-xs-10 nopad">
                        <div class="form-group note-taker-wrapper">
                            <textarea @keyup.ctrl.enter="addNote()" v-model.trim="newNote.text" class="form-control" placeholder="Write note here"></textarea>
                            <label class="attach" for="attachments"><img src="./../assets/img/paperclip.png"></label>
                            <input type="file" id="attachments" @change="addAttachments($event, 'note')" multiple>
                            <button :class="{'disabled': uploading===true}" class="send" @click.prevent="addNote()"><img src="./../assets/img/airplane.png"></button>
                            <ul class="attachments">
                                <li v-for="attachment in newNote.attachments" v-if="isVideo(attachment) || isImage(attachment)">
                                    <video v-if="isVideo(attachment)">
                                        <source :src="attachment">
                                    </video>
                                    <img v-if="isImage(attachment)" :src="getThumbnail(attachment)">
                                </li>
                            </ul>
                            <ul class="files">
                                <li v-for="attachment in newNote.attachments" v-if="!isVideo(attachment) && !isImage(attachment)">
                                    <a :href="attachment" target="_blank">{{attachment.split('/').pop()}}</a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="feed == localStorage.user_id && !localStorage.roles.includes('Mentor') && !localStorage.roles.includes('Admin')" class="text-right">Notify Mentor of this Post? <input type="checkbox" v-model="newNote.sendNotification"></div>
                    </div>
                    <div class="col-xs-2 tags">
                        <select class="form-control" v-model="newNote.projects">
                            <option value="" default selected>Project</option>
                            <option v-for="project in projects" :style="{backgroundColor: project.color}" :value="project.id">
                                {{project.name}}
                            </option>
                        </select>
                        <select @change="selectProject()" class="form-control" v-model="newNote.assets">
                            <option value="" default selected>Asset</option>
                            <option v-for="asset in assets" :style="{backgroundColor: getProjectColor(asset.projectId)}" :value="asset.id">{{asset.name}}</option>
                        </select>
                        <select class="form-control" v-model="newNote.categories">
                            <option value="" default selected>Task</option>
                            <option v-for="category in categories" :value="category.id">{{category.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-xs-3 sidebar">
                <ul class="members" v-if="members && !localStorage.roles.includes('Admin')">
                    <li @click="feed=member.id" v-for="member in members">
                        <div>
                            <img v-if="member.avatar" class="avatar" :class="{'active': member.id==feed}" :src="member.avatar" :alt="member.firstName + ' ' + member.lastName" :title="member.firstName + ' ' + member.lastName">
                            <img v-else class="avatar" :class="{'active': member.id==feed}" src="static/static/img/mentorship-avatar.jpg" :alt="member.firstName + ' ' + member.lastName" :title="member.firstName + ' ' + member.lastName">
                            <span class="name">{{member.firstName}} {{member.lastName}} 
                                <span v-if="!member.roles.includes('Mentor') && localStorage.roles.includes('Mentor') && localStorage.venue === 'both'">
                                    (<span v-if="member.roles.includes('CampusStudent') || member.transitioned === true ">Campus</span>
                                    <span v-else>Online</span>)
                                    
                                </span>
                            </span>
                        </div>
                    </li>
                </ul>
                <div class="members admin" v-if="members && localStorage.roles.includes('Admin')">
                    <ul v-for="(users, id) in members">
                        <li :class="{'is-mentor': member.roles.includes('Mentor')}" @click="feed=member.id" v-for="member in users">
                            <div v-if="member.roles.includes('Mentor')">
                                {{member.firstName}} {{member.lastName}}
                            </div>
                            <div v-else>
                                <img v-if="member.avatar" class="avatar" :class="{'active': member.id==feed}" :src="member.avatar" :alt="member.firstName + ' ' + member.lastName" :title="member.firstName + ' ' + member.lastName">
                                <img v-else class="avatar" :class="{'active': member.id==feed}" src="static/static/img/mentorship-avatar.jpg" :alt="member.firstName + ' ' + member.lastName" :title="member.firstName + ' ' + member.lastName">
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="localStorage.roles.includes('Mentor')" class="text-center">
                    <a @click.prevent="showScheduler=true" class="schedule-sessions" href="#">
                        Schedule Meeting(s)
                    </a>
                </div>
                <div class="panel">
                    <div class="panel-heading">
                        <h2>Note Structure</h2>
                    </div>
                    <div class="panel-body" v-if="assets && projects">
                        <h3>Projects / Categories</h3>
                        <ul class="projects" v-if="projects">
                            <li v-for="project in projects" :id="'project_' + project.id" @dragstart="dragstart($event, project, 'project')" draggable="true">
                                <span class="swatch" :style="{backgroundColor:project.color}"></span>
                                <span class="structure-name">{{project.name}}</span>
                                <i v-if="feed==localStorage.user_id || localStorage.roles.includes('Mentor')" @click="projectToEdit=project" class="fa fa-pencil"></i>
                                <div v-if="projectToEdit.id === project.id" class="row">
                                    <input type="text" class="form-control" placeholder="Name" v-model.trim="projectToEdit.name">
                                    <ul class="colors">
                                        <li v-for="color in colors">
                                            <input type="radio" :id="color" v-model="projectToEdit.color" :value="color">
                                            <label :for="color" :class="{'selected': projectToEdit.color == color}" :style="{backgroundColor: color}"></label>
                                        </li>
                                    </ul>
                                    <ul class="icons">
                                        <li><i @click.prevent="deleteProject()" class="fa fa-close"></i></li>
                                        <li><i @click.prevent="updateProject()" class="fa fa-save"></i></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div v-if="feed==localStorage.user_id || localStorage.roles.includes('Mentor')">
                            <i @click="projectToEdit = {id:null}; showNewProject=!showNewProject" class="fa fa-plus"></i>
                            <form class="new-structure" v-if="showNewProject">
                                <i @click="showNewProject=false" class="fa fa-close"></i>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Name" v-model.trim="newProject.name">
                                    <ul class="colors">
                                        <li v-for="color in colors">
                                            <input type="radio" :id="color" v-model="newProject.color" :value="color">
                                            <label :for="color" :class="{'selected': newProject.color == color}" :style="{backgroundColor: color}"></label>
                                        </li>
                                    </ul>
                                    <button @click.prevent="addProject()" class="btn btn-success">Add</button>
                                </div>
                            </form>
                        </div>
                        <h3>Assets</h3>
                        <ul class="projects">
                            <li v-for="asset in assets" :id="'asset_' + asset.id" @dragstart="dragstart($event, asset, 'asset')" draggable="true">
                                <span class="swatch" v-if="asset.projectId" :style="{backgroundColor:getProjectColor(asset.projectId)}"></span><span class="structure-name">{{asset.name}}</span>
                                <i v-if="feed==localStorage.user_id || localStorage.roles.includes('Mentor')" @click="assetToEdit=asset" class="fa fa-pencil"></i>
                                <div v-if="assetToEdit.id === asset.id" class="row">
                                    <input type="text" class="form-control" placeholder="Name" v-model.trim="assetToEdit.name">
                                    <select v-model="assetToEdit.projectId" class="form-control">
                                        <option value="" default selected>Project</option>
                                        <option v-for="project in projects" :style="{backgroundColor: project.color}" :value="project.id">{{project.name}}</option>
                                    </select>
                                    <ul class="icons">
                                        <li><i @click.prevent="deleteAsset()" class="fa fa-close"></i></li>
                                        <li><i @click.prevent="updateAsset()" class="fa fa-save"></i></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div v-if="feed==localStorage.user_id || localStorage.roles.includes('Mentor')">
                            <i @click="assetToEdit = {id:null}; showNewAsset=!showNewAsset" class="fa fa-plus"></i>
                            <form class="new-structure" v-if="showNewAsset">
                                <i @click="showNewAsset=false" class="fa fa-close"></i>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Name" v-model.trim="newAsset.name">
                                </div>
                                <div class="form-group" v-if="projects">
                                    <select v-model="newAsset.projectId" class="form-control">
                                        <option value="" default selected>Project</option>
                                        <option v-for="project in projects" :style="{backgroundColor: project.color}" :value="project.id">{{project.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <button @click.prevent="addAsset()" class="btn btn-success">Add</button>
                                </div>
                            </form>
                        </div>
                        <h3>Tasks</h3>
                        <ul class="projects" v-if="categories">
                            <li v-for="category in categories" :id="'category_' + category.id" @dragstart="dragstart($event, category, 'category')" draggable="true">
                                <span class="structure-name">{{category.name}}</span>
                                <i v-if="feed==localStorage.user_id || localStorage.roles.includes('Mentor')" @click="categoryToEdit=category" class="fa fa-pencil"></i>
                                <div v-if="categoryToEdit.id === category.id" class="row">
                                    <input type="text" class="form-control" placeholder="Name" v-model.trim="categoryToEdit.name">
                                    <ul class="icons">
                                        <li><i @click.prevent="deleteCategory()" class="fa fa-close"></i></li>
                                        <li><i @click.prevent="updateCategory()" class="fa fa-save"></i></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div v-if="feed==localStorage.user_id || localStorage.roles.includes('Mentor')">
                            <i @click="categoryToEdit = {id:null}; showNewCategory=!showNewCategory" class="fa fa-plus"></i>
                            <form class="new-structure" v-if="showNewCategory">
                                <i @click="showNewCategory=false" class="fa fa-close"></i>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Name" v-model.trim="newCategory.name">
                                </div>
                                <div class="form-group">
                                    <button @click.prevent="addCategory()" class="btn btn-success">Add</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div @click="lightboxImages=null" @keyup.esc="lightboxImages=null" class="lightbox" v-if="lightboxImages" tabindex="0">
            <i class="fa fa-remove" @click="lightboxImages=null"></i>
            <swiper :options="swiperOptions" ref="lightbox">
                <swiper-slide @click.stop v-for="slide in lightboxImages">
                    <video ontrols controlsList="nodownload" v-if="isVideo(slide)" @click.stop width="600" controls>
                        <source :src="slide">
                    </video>
                    <img v-else @click.stop :src="slide">
                    <div class="media-buttons-wrapper">
                        <a target="_blank" :href="slide">
                            <i class="fa fa-arrow-down"></i>
                        </a>
                    </div>
                </swiper-slide>
                <div @click.stop v-if="lightboxImages.length > 1" class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                <div @click.stop v-if="lightboxImages.length > 1" class="swiper-button-next swiper-button-white" slot="button-next"></div>
            </swiper>
        </div>
        <mentor-session-scheduler :members="members" v-if="localStorage.roles.includes('Mentor') && showScheduler === true">
        </mentor-session-scheduler>
        <div class="hider"></div>
    </section>
</template>
<script>
import timeline from './widgets/Timeline.vue';


import mentors from '../services/mentors';
import projects from '../services/mentors/projects';
import assets from '../services/mentors/assets';
import categories from '../services/mentors/categories';
import notes from '../services/mentors/notes';
import aws from '../services/aws';
import meetings from '../services/meetings';

import Timeline from './widgets/Timeline.vue';
import MentorCalendar from './widgets/MentorCalendar';
import MentorSessionScheduler from './widgets/MentorSessionScheduler';
import countdown from './reusable/countdown/CountdownTimer.vue';

import moment from 'moment';
import axios from 'axios';
import _ from 'underscore';
import toastr from 'toastr';
import tinygradient from 'tinygradient';
import jquery from 'jquery';
import 'jquery-ui-bundle';
import pasteImage from 'paste-image';
import { focus } from 'vue-focus';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

const uuidV4 = require('uuid/v4');

window.$ = window.jQuery = jquery

export default {
    data() {
        return {
            expanded: false,
            initialLoad: true,
            feed: null,
            members: null,
            colors: ['#deb704', '#3ac384', '#879ADE', '#F56765', '#DF7CEB'],
            showNewProject: false,
            newProject: { name: null, color: null },
            projects: null,
            showNewAsset: false,
            assets: null,
            newAsset: { name: null, projectId: "" },
            showNewCategory: false,
            categories: false,
            newCategory: { name: null },
            offset: 0,
            notes: null,
            from: null,
            // to: null,
            paginate: true,
            timelineNotes: null,
            showScheduler: false,
            newNote: {
                text: null,
                group: parseInt(localStorage.mentor_group),
                attachments: [],
                projects: '',
                assets: '',
                categories: '',
                sendNotification: false
            },
            selectedTask: null,
            uploading: false,
            replyTo: null,
            replyNote: { text: null, attachments: [] },
            updateData: null,
            noteToEdit: { noteId: null, text: null },
            projectToEdit: { id: null },
            assetToEdit: { id: null },
            categoryToEdit: { id: null },
            searchTerm: null,
            query: { project: '', asset: '', category: '', completed: true },
            lightboxImages: null,
            locations: [
                { id: 'green_lab', name: 'Characters for Film (Green Lab)' },
                { id: 'orange_lab', name: 'Texturing (Orange Lab)' },
                { id: 'blue_lab', name: 'Characters for Games (Blue)' },
                { id: 'fish_bowl', name: 'Fish Bowl' },
                { id: 'black_lab', name: 'Black Lab' },
                { id: 'penthouse_north', name: 'Penthouse North' },
                { id: 'penthouse_south', name: 'Penthouse South' },
                { id: 'remote', name: 'Remote' }
            ],
            swiperOptions: {
                keyboard: {
                    enabled: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    components: { MentorCalendar, MentorSessionScheduler, Timeline, swiper, swiperSlide, countdown },
    directives: {
        focus: focus,
        fcevent: {
            bind: function(el) {
                $(el).draggable({
                    zIndex: 99999999999,
                    revert: true,
                    revertDuration: 0,
                    appendTo: 'section',
                    containment: 'window',
                    scroll: false,
                    helper: 'clone'
                });
            }
        }
    },
    created() {

        if (this.$route.query.feed_id) {
            this.feed = this.$route.query.feed_id;
        } else {
            this.feed = localStorage.user_id;
        }
    },
    mounted() {
        var self = this;

        self.getMembers();
        // self.populate(); this is now fired by the watcher

        function goToNote() {
            if (!self.notes) {
                setTimeout(function() {
                    goToNote();
                }, 1000)
            } else {
                setTimeout(()=>{
                    try {
                        const note = document.getElementById('note' + self.$route.query.note_id);
                        const topPos = note.offsetTop;
                        document.getElementById('notes').scrollTop = topPos;
                    } catch(e) {
                        // do nothing
                    }
                },500);
            }
        }

        if (this.$route.query.note_id) {
            goToNote();
        }

        this.$on('goToId', function(id, date) {
            self.offset = 0;
            self.goToId(id, date);
        });

        pasteImage.on('paste-image', function(image) {
            fetch(image.src)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], uuidV4() + '.' + blob.type.split('/')[1], blob);
                    const event = { target: { files: [file] } };
                    let type;
                    document.activeElement.classList.contains('reply') ? type = 'reply' : type = 'note';
                    self.addAttachments(event, type);

                })
        });



        this.sockets.subscribe('noteAdded', (data) => {
            let note = data.message;
            if (note.feed != self.feed) return;

            let projectIds = note.projectIds;
            if (projectIds.length === 0) projectIds = ['none'];
            
            var container = document.getElementById("notes");
            var scrollToEnd = false;

            if (container.scrollHeight - container.scrollTop === container.clientHeight) scrollToEnd = true;

            if (note.parentNote) {
                let parent = self.notes.findIndex(function(n) { return n.id === note.parentNote });
                if (!self.notes[parent].children) {
                    self.notes[parent].children = [];
                }
                self.notes[parent].children.push(note)
            } else {
                self.notes.push(note)
            }

            let day = moment(note.createdAt).format('YYYY-MM-DD');

            if (!self.timelineNotes[day]) self.timelineNotes[day] = [];
            self.timelineNotes[day] = _.uniq(self.timelineNotes[day].concat(projectIds));

            self.$nextTick(function() {
                if (scrollToEnd === true) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        })

        this.sockets.subscribe('noteUpdated', (data) => {

            let note = data.message;
            if (!note || note.feed != self.feed) return;
            let index = self.notes.findIndex(function(n) { return n.id === note.id });

            let existingNote = self.notes[index];

            if (note.parentNote) {
                let parent = self.notes.findIndex(function(n) { return n.id === note.parentNote });
                self.$set(self.notes[parent].children, index, note);
                self.$forceUpdate();
            } else {

                self.$set(self.notes, index, note);
                self.$forceUpdate();

                if (note.tasks && note.tasks.length > 0) {
                    self.$nextTick(function() {
                        //  let lastTask = note.tasks[note.tasks.length - 1];
                        //   self.$refs['n'+note.id+'_t'+lastTask.id][0].focus();
                    });

                }
            }

        });

        this.sockets.subscribe('noteDeleted', (data) => {
            let note = data.message;
       
            let index = self.notes.findIndex(function(n) { return n.id === parseInt(data.message.id) });
            if (index > -1) {
                let day = moment(note.createdAt).format('YYYY-MM-DD');
                let notesForDay = self.notes
                            .filter(function(n) { return moment(n.createdAt).format('YYYY-MM-DD') == day })
                            .map((n)=> { if (n.projectIds.length === 0) n.projectIds = ['none']; return n;});
                let timelineDay = self.timelineNotes[day];

                if (!timelineDay) return;
                timelineDay.forEach(function(id, j) {
                    let stillHasNotes = notesForDay.filter(function(n) {
                        return n.projectIds.indexOf(id) > -1 && n.id != note.id;
                    });
                    if (stillHasNotes.length === 0) {
                        self.timelineNotes[day].splice(j, 1)
                    }
                });
                if (self.timelineNotes[day].length === 0) {
                    delete self.timelineNotes[day];
                }
                self.notes.splice(index, 1);
            }
        });

        this.sockets.subscribe('projectAdded',(data) => {
            let project = data.message;
            if (project.userId != self.feed) return;
            self.projects.push(project)
        });
        this.sockets.subscribe('assetAdded',(data) => {
            let asset = data.message;
            if (asset.userId != self.feed) return;
            self.assets.push(asset)
        });
        this.sockets.subscribe('categoryAdded',(data) => {
            let category = data.message;
            if (category.userId != self.feed) return;
            self.categories.push(category)
        });

    },
    watch: {
        'feed': function(feed) {   
            this.notes = null;
            this.assets = null;
            this.projects = null;
            this.categories = null;
            this.initialLoad = true;
            this.offset = 0;
            this.populate();  
        },
        selectedTask: function(task) {
            var self = this;
            this.$nextTick(function() {
                setTimeout(function() {
                    self.$refs[task][0].focus();
                }, 300)
            });
        }
    },
    methods: {
        showMeetingNote(meeting) {
            if (localStorage.venue == 'both') {
                const attendees = this.members.filter(a => meeting.participants.includes(a.id));
                const venues = attendees.map((a)=>{
                    if (a.roles.includes('Student') && a.transitioned !== true) return 'online';
                }).filter(v => v);

                if (venues[0] === 'online') {
                    return false;
                } 
            }
            return true;
        },
        getLocationName(id) {
            return this.locations.find(function(l) { return l.id === id }).name;
        },
        localTime(d) {
            if (!d) return;
            return moment(d).subtract(new Date().getTimezoneOffset() * -1, 'minutes').toDate();
        },
        getThumbnail(url) {

            url = url.replace('https://s3-us-west-2.amazonaws.com/ttto-note-attachments/', 'https://s3-us-west-2.amazonaws.com/ttto-note-attachments/')
            return url
        },
        toggleExpand() {
            this.expanded = !this.expanded;
            var route = this.$route;
            this.$router.replace({ name: 'mentorDashboard', query: { expanded: this.expanded, type: this.$route.query.type } })
        },
        populate() {
            var self = this;
            self.getProjects().then(self.getAssets());
            self.getCategories();
            self.getNotes();

        },
        search: _.debounce(function(e) {
            var self = this;
            self.getNotes(e, 'search')

        }, 500),

        updateTask: _.debounce(function(e, task, i, j, length) {
            var self = this;
            if (e.type === 'change') {
                if (task.name === null || task.name.trim() === '') {
                    this.notes[i].tasks[j].completed = false;
                    return false;
                }

                if (task.parentTask === null) {
                    mentors.updateTask(this, task)
                } else {
                    // don't let student mark a parent task as done until all the children are
                    let last = task.children[task.children.length - 1];
                    let children = task.children.slice(0);
                    if (!last.name || last.name.trim() === '') {
                        children.pop();
                        // if there's no actual task at the end, remove it;
                    }

                    let incomplete = children.filter(function(c) { return c.completed === false });

                    if (incomplete.length > 0) {
                        this.notes[i].tasks[j].completed = false;
                        toastr.error('Please finish all the sub-items first');
                        return;
                    }
                }

            }

            if (e.keyCode === 8 && !task.name) {
                mentors.deleteTask(this, task.id);
            }
            if (e.keyCode === 13) {
                if (!task.name || task.name.trim() === '') {
                    return false;
                }

                mentors.updateTask(this, task).then(function(done) {})

                if (e.shiftKey === true) {
                    task.parentTask = task.id;
                }

                if ((j + 1) === length) {
                    mentors.addTask(this, { noteId: task.noteId, parentTask: task.parentTask }).then(function(response) {
                        let newNoteRef = 'n' + response.data.task.noteId + '_t' + response.data.task.id;
                        self.selectedTask = newNoteRef;
                    });
                }

            }
        }, 250),

        handleScroll: _.debounce(function(e) {
            var self = this;

            if (e.target.scrollTop === 0 && self.notes.length > 99) {
                self.initialLoad = false;

                self.offset = self.offset + 100;
                self.getNotes();

            }
        }, 500),

        goToId(id, date) {
            var self = this;
            date = moment(date)
            if (typeof id === 'string') {
                id = id.replace(/_due/g, '');
            }

            var note = document.getElementById('note' + id);

            if (!note) {
                // this note is not yet loaded in the timeline
                self.notes = [];
                self.timelineNotes = {};
                self.query = { project: '', asset: '', category: '', completed: true };

                self.from = date.subtract(2, 'days').toDate(); // get all notes from event date, with a buffer

                self.getNotes().then(function(count) {
                    self.offset += count;
                    self.goToId(id, date);
                });
            } else {
                self.from = null;
                var topPos = note.offsetTop;
                document.getElementById('notes').scrollTop = topPos;
            }


        },

        goToDate(date) {

            let note = this.notes.find(function(n) {
                return moment(n.createdAt).format('YYYY-MM-DD') === date;
            });
            if (!note) return;

            var myElement = document.getElementById('note' + note.id);
            var topPos = myElement.offsetTop;
            document.getElementById('notes').scrollTop = topPos;

        },

        isVideo(file) {
            let videoExtensions = ['mp4', 'mov', 'webm', 'mpeg', 'mpg', 'avi']
            let extension = file.split('.').pop().toLowerCase();
            return videoExtensions.includes(extension);
        },
        isImage(file) {
            let imageExtensions = ['tif', 'tiff', 'jpeg', 'jpg', 'png', 'bmp', 'gif']
            let extension = file.split('.').pop().toLowerCase();
            return imageExtensions.includes(extension);
        },
        openLightbox(attachments, index) {
            var self = this;
            this.lightboxImages = attachments;
            self.$nextTick(function() {
                self.$refs.lightbox.swiper.slideTo(index, 0);
            });
        },
        addAttachments(event, type) {
            var self = this;
            //self.$store.dispatch('toggle',{type:'loading', boolean: true});
            self.uploading = true;
            let promises = [];
            let files;
            Array.isArray(event.target.files) ? files = event.target.files : files = Array.from(event.target.files);

            const bucket = 'ttto-note-attachments';

            files.forEach(function(file) {

                let fragments = file.name.split('.');
                let extension = fragments.pop();
                let filename = fragments.join('.') + '_' + Math.floor(Math.random() * (999 - 100 + 1) + 100) + '.' + extension;
                filename = filename.replace(/&|\$|@|=|;|:|\%|\+|,|\?/g, '');

                let promise = new Promise(async function(resolve, reject) {

                    let signature = await aws.signature(file, filename, bucket);
                    let presignedUrl = await aws.getPresignedUrl(self, bucket, filename, 'putObject');
                    let response = await aws.upload(file, filename, signature, bucket, presignedUrl.data);

                    if (self.isImage(filename)) {
                        axios.get('https://d5rr76493zoxb.cloudfront.net/' + filename).then(function() {
                            if (type === 'note') {
                                self.newNote.attachments.push(response.url);
                            } else if (type === 'reply') {
                                self.replyNote.attachments.push(response.url);
                            }
                            resolve();
                        })
                    } else {
                        if (type === 'note') {
                            self.newNote.attachments.push(response.url);
                        } else if (type === 'reply') {
                            self.replyNote.attachments.push(response.url);
                        }
                        resolve();
                    }


                });
                promises.push(promise);

            });


            Promise.all(promises).then(function() {
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                self.uploading = false;
            }).catch(function(e) {
                console.log(e);
                self.$store.dispatch('toggle', { type: 'loading', boolean: false });
                self.uploading = false;
            })

        },
        removeStructure(index, type, id) {
            let note = this.notes[index];
            let i = this.notes[index][type].findIndex(function(s) { return s === id });
            this.notes[index][type].splice(i, 1);
            let data = {
                noteId: this.notes[index].id
            }
            data[type] = this.notes[index][type];
            data.type = type.split('Ids')[0];
            notes.update(this, data);
            this.noteToEdit = { noteId: null, text: null }
        },
        attachStructure(e, note, index) {
            e.stopPropagation();
            e.preventDefault();
            let el = document.getElementById(e.dataTransfer.getData('itemid'));

            el.setAttribute('data-id', note.id);

            let data = this.updateData;
            data.noteId = note.id;
            switch (data.type) {
                case 'project':
                    if (note.projectIds.indexOf(data.id) > -1) {
                        toastr.error('This project is already associated with this note');
                        return false;
                    }
                    data.projectIds = note.projectIds.concat(data.id);
                    this.notes[index].projectIds = data.projectIds;
                    break;
                case 'asset':
                    if (note.assetIds.indexOf(data.id) > -1) {
                        toastr.error('This asset is already associated with this note');
                        return false;
                    }
                    data.assetIds = note.assetIds.concat(data.id);
                    this.notes[index].assetIds = data.assetIds;

                    if (data.projectId && note.projectIds.indexOf(data.projectId) === -1) {
                        data.projectIds = note.projectIds.concat(data.projectId);
                        this.notes[index].projectIds = data.projectIds;
                    } else {
                        delete data.projectIds;
                    }

                    break;
                case 'category':
                    if (note.categoryIds.indexOf(data.id) > -1) {
                        toastr.error('This category is already associated with this note');
                        return false;
                    }

                    data.categoryIds = note.categoryIds.concat(data.id);
                    this.notes[index].categoryIds = data.categoryIds;
                    this.notes[index].completed = false;
                    data.text = note.text;

                    break;
            }

            notes.update(this, data).then(function(response) {});
        },
        dragover(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        dragstart(e, data, type) {
            data.type = type;
            var id = e.target.id;
            e.dataTransfer.setData("itemid", id);
            if (type === 'project' && this.projectToEdit.id !== null) {
                e.preventDefault();
                return false;
            }
            if (type === 'asset' && this.assetToEdit.id !== null) {
                e.preventDefault();
                return false;
            }
            if (type === 'category' && this.categoryToEdit.id !== null) {
                e.preventDefault();
                return false;
            }
            this.updateData = data;
        },
        getMembers() {
            var self = this;
            mentors.getGroup(this).then(function(response) {
                if (response.data.success === true) {
                    let members = response.data.members;

                    if (localStorage.roles.includes('Admin')) {
                        members = members.map(function(m) {
                            m.group = m.group.sort(function(a, b) { return a - b });
                            m.group = m.group[m.group.length - 1];
                            return m;
                        }).sort(function(a, b) {
                            return b.roles.includes('Mentor') - a.roles.includes('Mentor')
                        })
                        members = _.groupBy(members, 'group');
                    }
                    self.members = members;
                } else {
                    toastr.error('Group members not found');
                }
            });
        },
        selectProject() {

            var self = this;
            if (!this.newNote.assets) this.newNote.projects = "";
            let asset = this.assets.find(function(a) { return a.id === self.newNote.assets })
            if (!asset.projectId) this.newNote.projects = "";
            this.newNote.projects = asset.projectId

        },

        getNotes(e, type, from, to) {
            var self = this;

            if (e && type) {
                self.initialLoad = true;
                self.notes = [];
                self.timelineNotes = {};
                self.offset = 0;
            }



            let query = '?feed=' + self.feed + '&offset=' + self.offset;

            Object.keys(self.query).forEach(function(q) {
                query += '&' + q + '=' + self.query[q];
            });

            if (type === 'search') {
                query += '&search=' + self.searchTerm;
            }
            if (self.from) {
                query += '&from=' + this.from;
            }


            console.log(query)

            self.$store.dispatch('toggle', { type: 'loading', boolean: true });

            return new Promise(function(resolve, reject) {
                notes.get(this, query).then(function(response) {

                    console.log(response)

                    if (response.data.success === true) {

                        if (!self.notes) {
                            self.notes = [];
                        } else {
                            var scrollPosition = self.$refs.notes.scrollHeight;
                        }

                        response.data.notes = response.data.notes.map(function(n) {
                            n.createdAt = moment.tz(n.createdAt, moment.tz().guess);
                            // if (n.dueDate) n.dueDate = moment.tz(n.dueDate, moment.tz.guess()).toDate();
                            return n;
                        })

                        self.notes = response.data.notes.concat(self.notes)

                        const day = note => moment(note.createdAt).format('YYYY-MM-DD');

                        const flatten = function(arr, result = []) {
                            for (let i = 0, length = arr.length; i < length; i++) {
                                const value = arr[i];
                                if (Array.isArray(value)) {
                                    flatten(value, result);
                                } else {
                                    result.push(value);
                                }
                            }
                            return result;
                        };

                        let timelineNotes = response.data.notes.map(function(n) {
                            return {
                                createdAt: moment(n.createdAt).tz(moment.tz.guess()),
                                projectIds: n.projectIds
                            }
                        })

                        timelineNotes = _.groupBy(timelineNotes, day)

                        if (!self.timelineNotes) self.timelineNotes = {};

                        Object.keys(timelineNotes).forEach(function(key) {
                            let projects = timelineNotes[key];
                            projects = projects.map(function(n) {
                                if (!n.projectIds || n.projectIds.length === 0) {
                                    return ['none'];
                                }

                                return n.projectIds.filter(function(i) { return i !== null });
                            })
                            projects = _.uniq(flatten(projects));


                            let exists = self.timelineNotes[key];

                            if (!exists) {
                                self.timelineNotes[key] = projects;
                            } else {
                                self.timelineNotes[key] = _.uniq(self.timelineNotes[key].concat(projects));
                            }
                        });

                        let ordered = {};

                        Object.keys(self.timelineNotes).sort().forEach(function(key) {
                            ordered[key] = self.timelineNotes[key];
                        });

                        self.timelineNotes = ordered;

                    } else {
                        if (response.data.message) {
                            toastr.error(response.data.message);
                            if (response.data.message.includes('at term start')) {
                                self.$router.push('/mentor-selector');
                            }
                        } else {
                            toastr.error('Error getting notes');
                        }
                    }

                    self.$store.dispatch('toggle', { type: 'loading', boolean: false });

                    self.$nextTick(function() {
                        var container = document.getElementById("notes");
                        if (container) {
                            setTimeout(function() {
                                if (self.initialLoad === true) {
                                    container.scrollTop = container.scrollHeight;
                                } else {
                                    container.scrollTop = container.scrollHeight - (scrollPosition + 50);
                                }
                            }, 500);
                        }
                    });


                    if (response.data.notes) {
                        resolve(response.data.notes.length);
                    } else {
                        resolve(0);
                    }
                });
            });
        },
        projectName(id) {

            let project = this.projects.find(function(p) { return p.id === id });
            if (project) return project.name;
            return null;
        },
        assetName(id) {
            let asset = this.assets.find(function(a) { return a.id === id });
            if (asset) return asset.name;
            return null;
        },
        categoryName(id) {
            let category = this.categories.find(function(c) { return c.id === id });
            if (category) return category.name;
            return null;
        },
        noteColor(projectIds) {
            if (projectIds.length === 0 || projectIds[0] === 'none') return 'linear-gradient(#363636, #363636, #363636)';
            let colors = this.projects.filter(function(p) {
                return projectIds.indexOf(p.id) > -1
            }).map(function(p) {
                return p.color;
            });
            if (colors.length < 2) return 'linear-gradient(' + colors[0] + ', ' + colors[0] + ', ' + colors[0] + ')';
            var gradient = tinygradient(colors);
            var css = gradient.css();

            return css;
        },
        createMeetingNote(note) {
            var self = this;

            if (!note.attended || note.attended === false) {
                toastr.error('Please confirm your attendance');
                return false;
            }
            if (self.feed != localStorage.user_id) {
                toastr.error('You can only confirm your own attendance at a meeting');
                return false;
            }
            note = {
                id: note.id,
                feed: self.feed
            }

            meetings.addCampusMeetingNote(this, note).then(function(response) {

                if (response.data.success === true) {
                    let existingNote = self.notes.find(function(n) { return n.id === note.id });
                    existingNote.meetingNote.push(response.data.note);
                } else {
                    if (self.feed != localStorage.user_id) {
                        toastr.error('You can only leave meeting notes on your own feed');
                    } else {
                        toastr.error('Error adding notes');
                    }
                }
            });

        },
        updateNote() {
            var self = this;
            let update = this.noteToEdit;
            update.type = 'text';
            update.feed = this.feed;

            notes.update(this, update);

            self.noteToEdit = { noteId: null, text: null }

        },
        addNote() {
            var self = this;
            if (!this.newNote.text) return;

            this.newNote.feed = this.feed;

            notes.create(this, this.newNote).then(function(response) {
                if (response.data.success !== true) {
                    toastr.error('Error adding note');
                } else {
                    self.newNote.text = null;
                    self.newNote.attachments = [];
                }
            });
        },
        deleteNote(id, index, childIndex) {
            var self = this;

            var yes = confirm('Are you sure you want to delete this?');
            if (yes === true) {
                notes.delete(this, id);
            }
        },
        sendReply(note) {
            var self = this;
            let reply = {
                author: localStorage.user_id,
                group: localStorage.mentor_group,
                text: this.replyNote.text,
                parentNote: note.id,
                feed: this.feed,
                attachments: this.replyNote.attachments
            }

            notes.create(this, reply).then(function(response) {
                if (response.data.success !== true) {
                    toastr.error('Error adding note');
                } else {
                    self.replyTo = null;
                    self.replyNote = { text: null, attachments: [] };
                }
            });
        },
        getProjects() {
            var self = this;
            return new Promise(function(resolve, reject) {
                projects.get(self, self.feed).then(function(response) {
                    response.data.success === true ? self.projects = response.data.projects : toastr.error('Error getting projects');
                    resolve();
                });
            });
        },
        updateProject() {
            var self = this;
            projects.update(this, this.projectToEdit).then(function(response) {
                response.data.success === false ? toastr.error('Error updating') : toastr.success('Updated');
                self.projectToEdit = { id: null }
            });
        },
        deleteProject() {
            var self = this;
            var yes = confirm('Are you sure you want to delete this?')
            if (yes === true) {
                projects.delete(this, this.projectToEdit.id).then(function(response) {
                    response.data.success === false ? toastr.error('Error deleting') : toastr.success('Deleted');
                    self.getProjects();
                    self.getAssets();
                    self.projectToEdit = { id: null }
                });
            }
        },
        addProject() {
            var self = this;
            if (!this.newProject.color) {
                toastr.error('Please select a colour');
                return;
            }
            this.newProject.feed = this.feed;
            projects.create(this, this.newProject).then(function(response) {
                if (response.data.success === true) {
                    if (!self.projects) self.projects = [];
                    self.projects.push({ id: response.data.id, name: self.newProject.name, color: self.newProject.color })
                    self.newProject = { name: null, color: null };
                } else {
                    toastr.error('Error adding project');
                }
                self.getProjects();
            });
        },
        getProjectColor(projectId) {

            if (this.projects.length === 0) return;
            if (projectId === 'none') return '#363636';
            let project = this.projects.find(function(p) { return p.id === projectId });
            if (project) return project.color;
        },
        getAssets() {
            var self = this;
            assets.get(self, self.feed).then(function(response) {
                if (!self.assets) self.assets = [];
                response.data.success === true ? self.assets = response.data.assets : toastr.error('Error getting assets');
            });
        },
        addAsset() {
            var self = this;
            let newAsset = this.newAsset;
            this.newAsset.feed = this.feed;
            if (newAsset.projectId == "") delete newAsset.projectId;

            assets.create(this, newAsset).then(function(response) {
                if (response.data.success === true) {
                    self.getAssets();
                    self.newAsset = { name: null, projects: null };
                } else {
                    toastr.error('Error adding project');
                }
                self.getProjects();
            });
        },
        updateAsset() {
            var self = this;
            assets.update(this, this.assetToEdit).then(function(response) {
                response.data.success === false ? toastr.error('Error updating') : toastr.success('Updated');
                self.assetToEdit = { id: null }
            });
        },
        deleteAsset() {
            var yes = confirm('Are you sure you want to delete this?')
            if (yes === true) {
                var self = this;
                assets.delete(this, this.assetToEdit.id).then(function(response) {
                    response.data.success === false ? toastr.error('Error deleting') : toastr.success('Deleted');
                    self.getAssets();
                    self.assetToEdit = { id: null }
                });
            }
        },
        getCategories() {
            var self = this;
            categories.get(this, this.feed).then(function(response) {
                response.data.success === true ? self.categories = response.data.categories : toastr.error('Error getting categories');
            });
        },
        addCategory() {
            var self = this;
            this.newCategory.feed = this.feed;
            categories.create(this, this.newCategory).then(function(response) {
                if (response.data.success === true) {
                    self.newCategory = { name: null };
                } else {
                    toastr.error('Error adding category');
                }
            });
        },
        updateCategory() {
            var self = this;
            categories.update(this, this.categoryToEdit).then(function(response) {
                response.data.success === false ? toastr.error('Error updating') : toastr.success('Updated');
                self.categoryToEdit = { id: null }

            });
        },
        deleteCategory() {
            var yes = confirm('Are you sure you want to delete this?')
            if (yes === true) {
                var self = this;
                categories.delete(this, this.categoryToEdit.id).then(function(response) {
                    response.data.success === false ? toastr.error('Error deleting') : toastr.success('Deleted');
                    self.getCategories();
                    self.categoryToEdit = { id: null }

                });
            }
        },
        getAvatar(id) {
            var self = this;
            let members = [];

            if (localStorage.roles.includes('Admin')) {
                Object.keys(this.members).forEach(function(m) {
                    members = members.concat(self.members[m])
                });
            } else {
                members = this.members;
            }

            let member = members.find(function(m) { return m.id == id })
            if (member && member.avatar) return member.avatar;
            return 'static/static/img/mentorship-avatar.jpg';
        }
    },
    computed: {
        terms() {
            return this.$store.state.terms;
        },
    }
}

</script>
<style lang="scss" scoped>
.files {

    //  padding:1rem;
    a {
        font-size: 13px;
    }
}

.completed-filter {

    a {
        line-height: 45px;
        display: inline-block;
        color: inherit;
        text-decoration: underline;
        cursor: pointer;
    }
}

.fa-expand {
    margin-right: 1rem;
    cursor: pointer;
}

.date,
.note-footer {
    font-size: 13px;
}

.delete-note {
    float: right;
}

.schedule-sessions {
    text-decoration: underline;
    margin-bottom: 1rem;
    display: inline-block;
}

.mentor-dashboard>.timeline {
    height: 175px;

    &.mentor {
        height: 110px;
    }
}


.attachments {
    display: flex;
    padding: 3rem 0 2rem;
    margin-bottom: -2rem;
    clear: both;

    li {
        overflow: hidden;
        margin: 0 5px;
        position: relative;
        width: 100px;
        height: 100px;

        .hover {
            cursor: pointer;
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            height: 100px;
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, .5);
            display: none;

            img {
                width: 40px;
                height: 40px;
            }
        }

        &:hover .hover {
            display: flex;
        }

    }

    li>img,
    li>video {
        width: 100px;
        height: 100px;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }

    i {
        //display:none;
    }

}

.children .attachments li .hover {
    width: 75px;
    height: 75px;
}

.notes .attachments {
    margin-left: -5px;
    margin-right: -5px;

}

.notes .reply-note .attachments {
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
}

.new-structure {
    .fa-close {
        float: right;
        margin-right: 1rem;
        cursor: pointer;
    }
}

.filters {
    display: flex;
    justify-content: space-around;
    width: 400px;
}

.children {
    padding-left: 10rem;
    margin-bottom: 2rem;

    &>li {
        margin-top: 1rem;
    }

    .note-text {
        background: #363636;
        padding: 0 .5rem;

        .text {
            margin: -1rem 0;
            word-break: break-word;
        }
    }

    .attachments {

        img {
            width: 75px;
            height: 75px;
            object-fit: cover;
        }
    }
}

.campus-meeting-avatars {
    img {
        margin-bottom: 1rem;
    }
}

.campus-meeting {
    background: #3cf;
    color: #1a1a1a;
    padding: .5rem;

    ::placeholder {
        color: #1a1a1a;
    }

    textarea {
        display: block;
        width: 100%;
        background: transparent;
        height: 10rem;
        resize: none;
    }

    .meeting-notes {
        white-space: pre-line;
        padding-bottom: 1rem;
    }

    .confirm-attendance {
        text-align: right;

        .fa-check-square-o {
            display: none;
        }

        i {
            cursor: pointer;
            font-size: 1.8rem;
            position: relative;
            top: 2px;
        }

        input {
            display: none;

            &:checked~i {
                &.fa-square-o {
                    display: none;
                }

                &.fa-check-square-o {
                    display: inline-block;
                }
            }
        }

        .btn {
            margin: .5rem 0;
            background: transparent;
            border: 1px solid #1a1a1a;
        }
    }
}

.note-text {
    .text {
        margin: -3.2rem 0;
        padding-left: 5px;

        &.uneditable {
            margin-top: -5rem;
        }
    }

    .edit {
        display: inline-block;
        position: absolute;
        top: 2px;
        right: 2px;
    }

    .fa {
        cursor: pointer;
    }

    .drag-note {
        position: absolute;
        top: 2px;
        left: 2px;
    }
}

.reply {
    float: right;
    cursor: pointer;
}

.timeline-wrapper {
    width: 150px;
    float: left;
    height: 620px;
    position: relative;

    &::after {
        content: '';
        width: 3px;
        height: 100%;
        display: block;
        background-color: #3cf;
        position: absolute;
        top: 0;
        left: 71px;
    }

}

.timeline {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 100%;

    li {
        display: flex;
        flex-wrap: nowrap;
        padding: 3rem 1rem;
        cursor: pointer;
    }

    .day {
        width: 40%;
    }

    .bubbles {
        width: 60%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        position: relative;
        z-index: 999999;
    }

    .bubble {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #222;
    }

    &::-webkit-scrollbar {
        width: 6px;
        background-color: #222;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #363636;
    }
}

.notes {
    width: calc(100% - 150px);
    float: left;
    //padding-right:2rem;
    overflow-y: scroll;
    height: 650px;
    position: relative;
    z-index: 1;

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(22, 22, 22, 0.3);
        background-color: #222;
    }

    &::-webkit-scrollbar {
        width: 10px;
        background-color: #222;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #363636;
        cursor: pointer;
    }

    &>li {
        padding: 2rem 0;
        padding-right: 1rem;
    }

    li {
        position: relative;
        z-index: 9999999999999;
    }

    .note-text {
        white-space: pre-wrap;

        &.completed {
            opacity: .5;
        }

        &.dark {
            color: #1a1a1a;

            ::placeholder {
                color: #1a1a1a;
            }

            .task {
                color: #1a1a1a;
            }
        }

        &.dark {
            input {
                color: #1a1a1a;
            }
        }
    }
}

.tasks {
    clear: both;
    margin-bottom: -3.5rem;
    margin-top: -3.5rem;
    padding-left: .5rem;

    //  margin-top:2rem;
    li {
        margin-bottom: -2rem;
        color: #fff;
        padding: .25rem 0;

        //display:flex;
        input {
            color: #b0b0b0;
        }

    }

    .task-children {
        padding-left: 2rem;
    }

    li>div {
        display: flex;
        width: 100%;

        input[type="checkbox"] {
            width: 10%;

        }

    }

    input[type=text] {
        position: relative;
        top: 2px;
    }

    input:focus {
        &::placeholder {
            color: lighten(#1a1a1a, 25%);
        }
    }

    .task {
        display: inline;
        position: relative;
        top: 3px;
        color: #b0b0b0;
        min-height: 2rem;
        min-width: 200px;
        display: block;
        padding-left: 2rem;
    }

    .task-name {
        background: transparent;
        width: 90%;
        margin-left: 20px;

        &::placeholder {
            color: transparent;
        }

        // padding:5px;

    }

}

.avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
}

.members {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    
    li {
        margin-bottom:10px;
    }

    &.admin {
        display: block;

        ul {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-bottom: 2rem;
            flex-wrap: wrap;

            li:first-child {
                width: 100%;
                font-weight: 600;
                font-size: 1.8rem;
            }

            li:not(:first-child) {
                flex: 1;
            }
        }

    }

    li {
        text-align: center;

        &:hover .name {
            text-decoration: underline;
        }
    }

    span.name {
        color: #3cf;
        display: block;
        cursor: pointer;

    }

    img {
        cursor: pointer;
        border: 2px solid transparent;
        border-radius: 50%;

        &.active {
            border: 2px solid #3cf;
        }
    }

}

.note-taker-wrapper {
    background: #363636 !important;
    position: relative;

    .files {
        padding: 1rem;
    }

    button {
        position: absolute;
        background: transparent;
        border: none;
        z-index: 999999999;
    }

    button.send {
        top: .25rem;
        right: .15rem;

        &.disabled {
            cursor: not-allowed !important;
            opacity: .5;
            pointer-events: none;
        }
    }

    .attach,
    .send {}

    .attach {
        position: absolute;
        top: .35rem;
        right: 3.5rem;
    }

    .attach+input {
        display: none;
    }

    .attachments {
        display: flex;
        flex-wrap: wrap;

        li {
            padding: 1rem;
        }
    }
}

.note-taker {
    textarea.form-control {
        padding-left: 1rem !important;
        background: #363636 !important;
        border: none !important;
        margin-top: 2rem;
        resize: none;
        height: 12rem;
    }
}

h3 {
    padding: 2rem;
    text-align: center;
}

.sidebar {
    h3 {
        padding: 0 0 0 1rem;
        font-weight: 100;
        text-align: left;
        font-size: 19px;
    }

    .fa {
        cursor: pointer;
    }

    .fa-plus {
        margin-left: 1.5rem;
    }

    .fa-pencil {
        float: right;
        position: relative;
        top: 8px;
    }

    .icons {
        display: flex;
        justify-content: space-around;
        margin-bottom: 2rem;
        margin-top: 1rem;
        color: #3cf;

        i {
            font-size: 2rem;
        }
    }

    .colors {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 1rem 0;

        input {
            display: none;
        }

        label {
            width: 25px;
            height: 25px;
            display: inline-block;
            border-radius: 50%;
            cursor: pointer;
            position: relative;

            &.selected {
                border: 2px solid transparent;
            }

            &.selected::after {
                content: '';
                width: 31px;
                height: 31px;
                display: inline-block;
                border-radius: 50%;
                border: 2px solid #3cf;
                position: relative;
                top: -5px;
                left: -5px;
            }
        }
    }

    .projects {
        padding: 1rem;

        li {
            line-height: 30px;

            .swatch {
                position: relative;
                top: 5px;
            }

            .swatch,
            .structure-name {
                cursor: move;
            }
        }
    }

}

.swatch {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-right: 1rem;
}

</style>
<style lang="scss">
.swiper-slide {
    &:hover .media-buttons-wrapper {
        display: block;
    }

    .media-buttons-wrapper {
        display: none;
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;

        a {
            width: 4rem;
            border-radius: 5px;
            padding: 4px 6px;
            margin-bottom: 10px;
            background-color: rgba(30, 30, 30, 0.4);
            font-size: 16px;
            color: rgba(255, 255, 255, 0.8);
            display: inline-block;
            padding: 4px;
            margin-right: 4px;

            &:hover {
                color: #33aaff;
            }
        }

        i {
            position: relative;
            top: 1px;
            right: 0;
        }
    }

}

.mentor-dashboard {
    .lightbox {
        i {
            z-index: 999999999999999;
        }

        .swiper-slide {
            min-width: 600px;
            width: 100% !important;
        }

        video {
            width: 600px;
        }

    }
}

.ui-draggable {
    max-width: 489px !important;
    z-index: 9999999999999 !important;
}

section.mentor-dashboard .hider~i {
    display: none !important;
}

</style>



// WEBPACK FOOTER //
// MentorDashboard.vue?33726ea8